import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  batchList: [],
}

export const getters = {}

export const mutations = {
  CACHE_BATCH_LIST(state, newList) {
    state.batchList = newList
  },
}

export const actions = {
  // batch List Service
  fetchBatchList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/batch/?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_BATCH_LIST', list)
        return list
      })
  },

  // Add batch Service
  addBatchData({ commit, state, rootState }, { batchData }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/batch`, batchData)
      .then((response) => {
        const batch = response.data
        return batch
      })
  },

  // Update batch Service
  updateBatchData({ commit, state, rootState }, { data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/batch/${data.id}`, data)
      .then((response) => {
        const batch = response.data
        return batch
      })
  },
}
